<script>
import ProductAttributesMixin from './mixins/product-attributes';

export default {
  name: 'ProductApplications',
  props: ['product'],
  mixins: [ProductAttributesMixin],
  computed: {
    reducedProductApplications() {
      return this.productApplications().map((a) => a.split('-')[0])
        .filter((a, i, array) => array.indexOf(a) === i);
    },
  },
  methods: {
    productApplications() {
      return this.getPropertyValues('Application')
        .split(',')
        .map((a) => a.trim().toUpperCase())
        .filter((a) => a.length > 0);
    },
    applicationColor(application) {
      let color = null;
      switch (application) {
        case 'D':
          color = 'bg-green-diagomics';
          break;
        case 'EL':
          color = 'bg-pink-600';
          break;
        case 'ELISA':
          color = 'bg-pink-400';
          break;
        case 'F':
          color = 'bg-red-400';
          break;
        case 'FACS':
          color = 'bg-red-600';
          break;
        case 'FC':
          color = 'bg-red-700';
          break;
        case 'FL':
          color = 'bg-red-900';
          break;
        case 'IB':
          color = 'bg-green-600';
          break;
        case 'ICC':
          color = 'bg-green-800';
          break;
        case 'IF':
          color = 'bg-green-500';
          break;
        case 'IF/ICC':
          color = 'bg-blue-400';
          break;
        case 'IHC':
          color = 'bg-orange-400';
          break;
        case 'IHC-F':
          color = 'bg-orange-600';
          break;
        case 'IHC-P':
          color = 'bg-orange-800';
          break;
        case 'P':
          color = 'bg-indigo-500';
          break;
        case 'RP':
          color = 'bg-red-500';
          break;
        case 'WB':
          color = 'bg-red-500';
          break;
        default:
          color = 'bg-gray-400';
      }
      return color;
    },
    applicationClass(application) {
      return `float-left text-white text-xs mt-1 md:mt-0 p-1 mr-1 rounded ${this.applicationColor(application)}`;
    },
  },
};
</script>

<template>
  <div>
    <span v-for="application in reducedProductApplications" :key="application"
          :class="applicationClass(application)">
              {{ application }}
    </span>
  </div>
</template>
